import moment from "moment";
import { useState } from "react";
import { BiSolidChevronDown, BiSolidChevronUp } from "react-icons/bi";
import { FiAlertTriangle } from "react-icons/fi";
import { Tooltip } from "antd";
import { Badge, Card, Table } from "reactstrap";

const getDistributorBadgeColor = (distName = "") => {
  const norm = String(distName || "").toLowerCase();
  if (norm.includes("own") || norm.includes("tmu")) return "success";
  if (norm.includes("teledynamics") || norm.includes("tele dynamics")) return "primary";
  if (norm.includes("d&h") || norm.includes("dnh")) return "info";
  if (norm.includes("ingram")) return "dark";
  if (norm.includes("asi")) return "warning";
  if (norm.includes("bluestar") || norm.includes("blue star")) return "primary";
  if (norm.includes("accutech")) return "info";
  return "primary";
};

const StockTable = ({ data }) => {
  const [showRows, setShowRows] = useState(false);
  const toggleRows = () => setShowRows(!showRows);
  const filteredData = data?.filter((row) => row?.distributor);
  if (!filteredData || filteredData.length === 0) return null;

  const displayRows = showRows || filteredData.length <= 4 ? filteredData : filteredData.slice(0, 3);

  return (
    <Card className="p-0 bg-secondary-color border-0 rounded overflow-hidden mt-2">
      <Table
        responsive
        hover
        bordered
        style={{
          fontSize: "13px",
          overflow: "hidden",
        }}
        className="mb-0 align-middle"
      >
        <thead className="table-light">
          <tr style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            <th style={{ width: "180px" }}>Source / Distributor</th>
            <th>Part Number / SKU</th>
            <th>Description</th>
            <th className="text-center" style={{ width: "90px" }}>Available</th>
            <th style={{ width: "100px" }}>Price / Cost</th>
            <th style={{ width: "110px" }}>Updated</th>
          </tr>
        </thead>
        <tbody>
          {displayRows.map((row, index) => {
            const rawDesc = (row?.description || row?.detailedInfo?.description || row?.raw?.description || "").replace(/[\r\n\t]+/g, " ").trim();
            const skuVal = row?.partNumber || row?.sku || row?.itemId || row?.raw?.itemId || "-";
            const qty = Number(row?.quantity ?? row?.totalAvailableQuantity ?? row?.raw?.totalAvailableQuantity ?? row?.stc_quantity ?? 0);
            const priceVal = row?.price !== undefined && row?.price !== null ? row.price : (row?.salesPrice ?? row?.cost ?? 0);
            const rawDate = row?.date_created || row?.raw?.PriceChangeDate || row?.raw?.date_created || row?.raw?.lastUpdateDate || row?.updated_at;
            const isTesting = row?.sandbox === true || row?.raw?.sandbox === true;

            return (
              <tr key={index} style={isTesting ? { backgroundColor: "#fffbeb" } : {}}>
                <td className="fw-bold d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex align-items-center gap-1.5 flex-wrap">
                    <Badge color={getDistributorBadgeColor(row?.distributor)} className="px-2 py-1 rounded-1 text-uppercase" style={{ fontSize: "11px" }}>
                      {row?.distributor}
                    </Badge>
                    {isTesting && (
                      <Tooltip title="Sandbox / Testing Environment: This stock & pricing data is retrieved from the testing environment.">
                        <span
                          className="d-inline-flex align-items-center justify-content-center p-1 rounded-circle pointer"
                          style={{
                            cursor: "help",
                            backgroundColor: "#fef3c7",
                            border: "1px solid #fde68a",
                            color: "#d97706",
                            width: "20px",
                            height: "20px"
                          }}
                        >
                          <FiAlertTriangle size={12} style={{ color: "#d97706" }} />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                  {index === 0 && filteredData.length > 4 && (
                    showRows ? (
                      <BiSolidChevronUp
                        color="#00509d"
                        size={18}
                        onClick={toggleRows}
                        style={{ cursor: "pointer" }}
                        title="Show less"
                      />
                    ) : (
                      <BiSolidChevronDown
                        color="#00509d"
                        size={18}
                        onClick={toggleRows}
                        style={{ cursor: "pointer" }}
                        title="Show all sources"
                      />
                    )
                  )}
                </td>
                <td className="fw-semibold text-dark">{skuVal}</td>
                <td title={rawDesc} style={{ maxWidth: "300px" }}>
                  <span className="text-truncate d-inline-block w-100" style={{ maxWidth: "300px", verticalAlign: "middle" }}>
                    {rawDesc || "-"}
                  </span>
                </td>
                <td className="text-center">
                  <span className={qty > 0 ? "badge bg-success-subtle text-success fw-bold" : "text-muted"}>
                    {qty}
                  </span>
                </td>
                <td className="fw-bold text-dark">
                  ${Number(priceVal).toFixed(2)}
                </td>
                <td className="text-muted small">
                  {rawDate ? moment(rawDate).format("M/D/YYYY") : "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default StockTable;
